import { useNavigate } from 'react-router-dom';
import { Column } from '../../../../../core/components/Column';
import { TextComponent } from '../../../../../core/components/TextComponent';
import { Container } from '../../../../../core/components/Container';
import { CustomButton } from '../../../../../core/components/CustomButton';
import { Row } from '../../../../../core/components/Row';
import { CircleArrow } from '../../../../../core/icons/CircelArrow';


export const OnboardingUnvaccinated = () => { 
  const navigate = useNavigate();
  
  const sections = [
    {
      title: 'Be yourself',
      description: 'Please make sure that your photos, age and bio are accurate and a true representation of who you are.'
    },
    {
      title: 'Play it cool',
      description: 'Respect others and treat them as you would like to be treated.'
    },
    {
      title: 'Stay safe',
      description: "Don't be too quick to give out personal information."
    },
    {
      title: 'Be proactive',
      description: 'Always report bad behavior.'
    }
  ];

  return (
    <Column
            crossAxisAlignment="center"
            className=" my-5 md:my-10"
        >
      <Container className="gap-5 bg-white px-4 md:px-10  md:p-20 self-center text-center w-full md:w-[584px] lg:shadow-xl rounded-lg" >
        <div className='text-center'>
          <div className='my-4'>
            <TextComponent variant='h6' className='mx-auto max-w-md text-center text-base font-medium leading-7 text-black'>
              Unjabbed is a community for people who value health freedom, honest connection, and relationships built on shared values.
            </TextComponent>
          </div>
          
          {sections.map((section, index) => (
            <Row key={index} className='flex flex-col md:flex-row items-start mb-6'>
              <div className='hidden md:block'>
                <CircleArrow />
              </div>
              <div className='md:w-4' />
              <Column crossAxisAlignment='start' className='w-full'>
                <TextComponent variant='h6' className='font-bold md:font-semibold' >
                  {section.title}
                </TextComponent>
                <TextComponent variant='h6' className='text-start text-gray-600 mt-2'>
                  {section.description}
                </TextComponent>
              </Column>
            </Row>
          ))}

          <div className='mt-8'>
            <CustomButton onClick={() => {navigate('/username')}} children='Got it' className='w-full ' />
          </div>
        </div>
      </Container>
    </Column>
  );
};
